import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24')
];

export const server_loads = [];

export const dictionary = {
		"/(accueil)": [2],
		"/accessibilite": [3],
		"/blog": [4],
		"/blog/5-idees-recues-sur-le-bail-reel-solidaire-brs": [5],
		"/blog/acheter-son-logement-sans-se-ruiner-3-solutions-a-connaitre-absolument": [6],
		"/blog/comment-savoir-si-je-suis-eligible-au-bail-reel-solidaire-brs": [7],
		"/blog/le-bail-reel-solidaire-brs-cest-quoi-exactement": [8],
		"/blog/puis-je-acheter-un-logement-en-brs-si-je-suis-deja-proprietaire": [9],
		"/blog/un-exemple-pour-vous-projeter-dans-votre-achat-en-brs": [10],
		"/conditions-generales-d-utilisation": [11],
		"/espace-presse": [12],
		"/logements-brs-disponibles": [~13],
		"/mentions-legales": [14],
		"/notre-mission": [~15],
		"/nous-contacter": [16],
		"/organismes-fonciers-solidaires": [~17],
		"/politique-de-confidentialite": [18],
		"/questionnaire": [19],
		"/revendre-mon-bien-en-brs": [20],
		"/simulateur-acquisition": [21],
		"/simulateur-eligibilite": [~22],
		"/tout-savoir-sur-le-bail-reel-solidaire-brs": [23],
		"/tout-savoir-sur-le-bail-reel-solidaire-brs/[slug]": [~24]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';